import React from 'react'
import { Typography } from '../../../../components/atoms/typography/index'
import CheckBoxGroup from '../../../../components/molecules/checkboxGroup/index'
import { CheckboxItem } from '../../../../contracts/checkboxItem'
import { AdditivesContainer } from './styles'

export interface AdditivesProps {
  paperVariant?: 'purple' | 'default'
  additives: CheckboxItem[]
  onCheck: (event: any) => void
}

const Additives = ({ paperVariant, additives, onCheck }: AdditivesProps) => {
  return (
    <AdditivesContainer title="Aditivos" variant={paperVariant}>
      <Typography fontSize="small" color="#6B6B6B">
        Aditivos são declarados ao final da lista de ingredientes da etiqueta —
        não entram na receita produtiva.
      </Typography>
      <CheckBoxGroup
        disabled={false}
        elements={additives}
        onSelect={onCheck}
        columns={2}
      />
    </AdditivesContainer>
  )
}

export default Additives
